(function () {
  'use strict'

  var MODULE_NAME = 'thismoment.playlist'

  require('angular')
    .module(MODULE_NAME, [
      require('./scss/playlist.scss'),
      require('../common/scss/loader.scss')
    ])

  require('angular')
    .module(MODULE_NAME, [
      require('./playlist')
    ])

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/playlist/index.js